export default "__VITE_PUBLIC_ASSET__7b0be052__"